import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '@app/components/icon/icon.component';
import { LoadingSpinnerComponent } from '@app/components/loading-spinner/loading-spinner.component';
import { DropDownButton } from '@app/models/elements/drop-down-button';

@Component({
	selector: 'app-drop-down-button',
	standalone: true,
	imports: [IconComponent, LoadingSpinnerComponent],
	templateUrl: './drop-down-button.component.html',
	styleUrl: './drop-down-button.component.css',
})
export class DropDownButtonComponent {
	@Input() dropdownButton: DropDownButton = {} as DropDownButton;
	@Input() showLoadingSpinner = false;

	@Output() clicked = new EventEmitter<string>();

	onClick = (buttonText: string) => {
		this.clicked.emit(buttonText);
	};
}
